import { useEffect, useRef } from 'react'

export interface ReiterEintrag<K extends string = string> {
  key: K
  label: string
  /** Fehler in diesem Reiter (rote Markierung) */
  fehler?: boolean
}

/**
 * Reiterleiste im Aussehen von AkkuDetail: scrollt waagerecht statt umzubrechen,
 * Touch-Ziele mindestens 44 px auf Tablet/Handy (pointer: coarse).
 */
export function Reiterleiste<K extends string>({ reiter, aktiv, onWechsel, testid = 'reiterleiste' }: {
  reiter: Array<ReiterEintrag<K>>
  aktiv: K
  onWechsel: (key: K) => void
  testid?: string
}) {
  const aktivRef = useRef<HTMLButtonElement | null>(null)
  useEffect(() => {
    aktivRef.current?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' })
  }, [aktiv])
  return (
    <div className="flex flex-nowrap gap-1 overflow-x-auto overflow-y-hidden border-b border-dark-border [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" role="tablist" data-testid={testid}>
      {reiter.map(r => (
        <button key={r.key} type="button" role="tab" aria-selected={aktiv === r.key} data-reiter={r.key}
          data-fehler={r.fehler ? 'true' : undefined}
          ref={aktiv === r.key ? aktivRef : undefined}
          onClick={() => onWechsel(r.key)}
          className={`shrink-0 whitespace-nowrap border-b-2 px-4 py-2 text-sm font-medium transition-colors [@media(pointer:coarse)]:min-h-[44px] ${aktiv === r.key
            ? 'border-primary-500 text-dark-text' : 'border-transparent text-dark-text-muted hover:text-dark-text'}`}>
          {r.label}
          {r.fehler && <span aria-label="Fehler in diesem Reiter" className="ml-1.5 inline-block h-2 w-2 rounded-full bg-red-500 align-middle" />}
        </button>
      ))}
    </div>
  )
}
